import { ThunkDispatch } from '@reduxjs/toolkit'
import { SocketEvent } from 'interface'
import { io, Socket } from 'socket.io-client'
import { EventAction, getEvent } from './slices/Event'
import { getOrganizer } from './slices/Organizer'
import { getQuizTemplate } from './slices/Quiz'
import { logout } from './slices/UI'
import type { RootState } from './store'

export class SocketClient {
  private dispatch: ThunkDispatch<any, any, any>
  private rootState: RootState
  private socket: Socket | null = null
  constructor(dispatch: ThunkDispatch<any, any, any>, rootState: RootState) {
    this.dispatch = dispatch
    this.rootState = rootState
  }
  connect() {
    const socket = io('/', {
      path: '/game-io',
      auth: this.rootState.UI.auth,
      transports: ['websocket', 'polling'],
    })
    this.socket = socket
    socket.on('connect_error', () => {
      socket.io.opts.transports = ['polling', 'websocket']
    })
    socket.on('connect', () => {
      process.env.NODE_ENV === 'development' &&
        console.log('Socket is connected')
      socket.on('disconnect', (r) => {
        console.log(r)
      })
      // eventIO
      socket.on('eventIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getEvent(event.id))
            break
          case 'deleted':
            this.dispatch(EventAction.removeItem(Number(event.id)))
            break
          case 'updated':
            this.dispatch(getEvent(event.id))
            break
          default:
            break
        }
      })
      // templateIO
      socket.on('templateIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'created':
            this.dispatch(getQuizTemplate(event.id))
            break
          case 'deleted':
            break
          case 'updated':
            this.dispatch(getQuizTemplate(event.id))
            break
          default:
            break
        }
      })
      // organizerIO
      socket.on('organizerIO', (event: SocketEvent) => {
        process.env.NODE_ENV === 'development' && console.log(event)
        switch (event.action) {
          case 'updated':
            this.dispatch(getOrganizer(event.id))
            break
          case 'logout':
            this.dispatch(logout())
            break
          default:
            break
        }
      })
    })
  }
  disconnect() {
    this.socket?.disconnect()
  }
}
